import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { CustomerGusDto, ValueTypeDto } from '@/api/generated';

type Return = {
  getGusCustomer: (req: string) => Promise<CustomerGusDto>;
  isGettingGusCustomer: boolean;
};

export const useGetGusCustomer = (): Return => {
  const { externalCustomersApi } = useApiClient();

  const { isPending, mutateAsync } = useMutation<CustomerGusDto, AxiosError, string>({
    mutationFn: async req => {
      const res = await externalCustomersApi.getGusCustomer(req, ValueTypeDto.Nip);

      return res.data;
    },
  });

  return {
    getGusCustomer: mutateAsync,
    isGettingGusCustomer: isPending,
  };
};
